import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import StaffDrawer from "components/drawer/StaffDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";
import ShowHideButton from "components/table/ShowHideButton";
import { FaCircle } from "react-icons/fa";
const StaffTable = ({
  staffdata,
  hideDelete,
  hideEdit,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate ,handleResetPassword} = useToggleDrawer();

  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <StaffDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {staffdata?.slice(0, ).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="text-center text-xs">
              { index + 1}
            </TableCell>

            <TableCell className="text-center text-xs">
            {data.name}
            </TableCell>
            <TableCell className="text-center text-xs">
            {data.email}
            </TableCell>  
           
            <TableCell className="text-center text-xs">
            {data.role}
            </TableCell>
            <TableCell className="text-center text-xs">
            <ShowHideButton id={data.id} status={data.status} />
            </TableCell>
            <TableCell className="text-center text-xs">
              <div className="flex justify-center items-center">
                {data.is_online ? (
                  <span className="text-green-500">
                    <FaCircle />
                  </span>
                ) : (
                  <span className="text-red-500">
                    <FaCircle />
                  </span>
                )}
              </div>
            </TableCell>
            <TableCell>
              <div className="flex justify-center">
                <EditDeleteButton
                  title={data.name}
                  id={data.id}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  handleResetPassword={handleResetPassword}
                  hideEdit={hideEdit}
                  hideDelete={hideDelete}
            
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default StaffTable;
